import * as React from "../../_snowpack/pkg/react.js";
import * as d3 from "../../_snowpack/pkg/d3.js";
import Rect from "./Rect.js";
const BarGraphComparison = ({
  id,
  title,
  instPercentage,
  natPercentage,
  stateData,
  instName,
  degreeText
}) => {
  const fullHeight = stateData ? 95 : 70;
  const fullWidthRatio = 0.8;
  const axisTransform = stateData ? 70 : 50;
  const barHeight = 20;
  const urmPopulationPercentage = stateData?.urmPopulationRatio ? stateData?.urmPopulationRatio * 100 : 0;
  const formattedWidth = Math.min(window.innerWidth * fullWidthRatio, 800);
  React.useEffect(() => {
    const graphSVG = d3.select(`#${id}`).append("svg").attr("width", formattedWidth || 0).attr("height", fullHeight).attr("transform", `translate(${formattedWidth === 800 ? 0 : window.innerWidth * (1 - fullWidthRatio) / 4}, 0)`).style("margin-top", "20px").style("overflow", "visible");
    const barWrapper = graphSVG.append("g");
    barWrapper.append("rect").attr("x", 2).attr("y", 5).attr("height", barHeight).attr("width", instPercentage / Math.max(instPercentage || 0, natPercentage, urmPopulationPercentage) * formattedWidth).attr("fill", "rgb(248, 113, 113)");
    barWrapper.append("rect").attr("x", 2).attr("y", 25).attr("height", barHeight).attr("width", natPercentage / Math.max(instPercentage || 0, natPercentage, urmPopulationPercentage) * formattedWidth).attr("fill", "rgb(96, 165, 250)");
    if (stateData) {
      barWrapper.append("rect").attr("x", 2).attr("y", 45).attr("height", barHeight).attr("width", urmPopulationPercentage / Math.max(instPercentage || 0, natPercentage, urmPopulationPercentage) * formattedWidth).attr("fill", "rgb(52, 211, 153)");
    }
    graphSVG.append("g").attr("transform", `translate(0,${axisTransform})`).call(d3.axisBottom(d3.scaleLinear().domain([
      0,
      Math.max(instPercentage || 0, natPercentage, urmPopulationPercentage) / 100
    ]).range([0, formattedWidth])).tickFormat(d3.format(".1%")).offset(3));
    return () => {
      d3.select(`#${id}`).selectChild("svg").remove();
    };
  }, [
    id,
    instPercentage,
    natPercentage,
    axisTransform,
    fullHeight,
    fullWidthRatio,
    stateData,
    formattedWidth,
    urmPopulationPercentage
  ]);
  return /* @__PURE__ */ React.createElement("div", {
    className: "mb-8"
  }, /* @__PURE__ */ React.createElement("h3", {
    className: "font-bold pb-4"
  }, title), /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-between w-full"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-center items-center  w-4/5 md:w-3/4 lg:w-2/3"
  }, /* @__PURE__ */ React.createElement(Rect, {
    color: "red"
  }), `${instName} - ${(instPercentage || 0).toFixed(2)}%`), /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-center items-center  w-4/5 md:w-3/4 lg:w-2/3"
  }, /* @__PURE__ */ React.createElement(Rect, {
    color: "blue"
  }), `U.S. Physics ${degreeText} - ${parseFloat(natPercentage.toFixed(3))}%`), stateData ? /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-center items-center w-4/5 md:w-3/4 lg:w-2/3"
  }, /* @__PURE__ */ React.createElement(Rect, {
    color: "green"
  }), `Percentage of URM in state population (${stateData.state}) - ${parseFloat(urmPopulationPercentage.toFixed(2))}%`) : /* @__PURE__ */ React.createElement(React.Fragment, null)), /* @__PURE__ */ React.createElement("div", {
    id
  }));
};
export default BarGraphComparison;
